export const USER_LOGIN_REQUEST = 'USER_LOGIN_REQUEST';
export const USER_LOGIN_SUCCESS = 'USER_LOGIN_SUCCESS';
export const USER_LOGIN_FAIL = 'USER_LOGIN_FAIL';
export const USER_LOGOUT = 'USER_LOGOUT';
export const USER_UPDATE_TOKEN = 'USER_UPDATE_TOKEN';
export const SET_LOADING = 'SET_LOADING';
export const USER_GET_SESSION = 'USER_GET_SESSION';
